import { styled } from 'styled-components'
import { LinkList, LinkListItem } from 'suomifi-ui-components'

export const StyledLinkList = styled(LinkList)``

export const StyledLinkListItem = styled(LinkListItem)`
  & .fi-icon {
    margin-left: ${(props) => props.theme.spacing.xs};
  }

  & .fi-icon:first-child {
    margin-left: 0;
    margin-right: ${(props) => props.theme.spacing.xs};
    width: 25px;
    height: 25px;
    vertical-align: top;
  }

  margin: ${(props) => props.theme.spacing.m} 0;
`
